import { render, staticRenderFns } from "./AiPrompt.vue?vue&type=template&id=cc3c7710&scoped=true&"
import script from "./AiPrompt.vue?vue&type=script&lang=ts&"
export * from "./AiPrompt.vue?vue&type=script&lang=ts&"
import style0 from "./AiPrompt.vue?vue&type=style&index=0&id=cc3c7710&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3c7710",
  null
  
)

export default component.exports